import { Phone } from 'lucide-react';
import CustomAILogo from '@/components/CustomAILogo';
import { CONTACT_PHONE } from '@/lib/constants';

export default function LandingHeader() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      data-testid="landing-header"
      className="fixed top-0 w-full z-50 backdrop-blur-xl border-b"
      style={{ backgroundColor: 'var(--c-bg-nav)', borderColor: 'var(--c-nav-border)' }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between h-16">
          <button
            type="button"
            onClick={scrollToTop}
            data-testid="landing-header-logo"
            aria-label="Scroll to top"
            className="flex items-center bg-transparent border-0 p-0 cursor-pointer"
          >
            <CustomAILogo to="/" height={36} />
          </button>

          <a
            href={`tel:${CONTACT_PHONE.replace(/\s/g, '')}`}
            data-testid="landing-header-phone"
            className="inline-flex items-center gap-2 text-sm md:text-base font-semibold text-brand-white no-underline hover:text-brand-blue-light transition-colors duration-200"
          >
            <Phone size={18} />
            {CONTACT_PHONE}
          </a>
        </div>
      </div>
    </header>
  );
}
